<template>
  <router-view name="memberReports" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "MemberReports",
};
</script>